export default "__VITE_ASSET__Dsfsa2ga__"